export default function AffEbay() {
  return (
    <a
      href="https://ebay.us/dDIQRc"   // ⭐ Your direct eBay affiliate link
      className="ebay-main-btn"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      eBay Store
    </a>
  );
}
 